// extracted by mini-css-extract-plugin
export default {"ActionsContainer":"PhotoGalleryControls-module__ActionsContainer__uTrv2"};